<template>
	<section>
		<compFormEdit :formdata="getBase" v-model="formData" placeholder="--"></compFormEdit>
		<compModal v-model="modalProps.show" v-bind="modalProps" @on-close="modalProps.show=false">
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				v-on="modalProps.on"
			/>
		</compModal>
		<vButtonGroup slot="footer" class="text-right">
			<vButton theme="primary" @click="saveStaff">确认</vButton>
			<vButton @click="close">取消</vButton>
		</vButtonGroup>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import compFindMember from './allmember.js';
import { HttpAddStaff, HttpGetStaffDetail } from '@/service/department/departmentmanage.js'
import { HttpGetAllRole } from '@/service/department/rolemanage.js'

import mixin from '../mixins'
export default {
    props:['selectDeptId','type','companyList','params'],
    mixins: [ mixin ],
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compModal: () => import("@components/templates/modal"),
		compFindMember,
	},
	data() {
		return {
			formData: {
                manageType: 0,
                approleIds: [],
                otherDeptIds: []
            },
			loading: false,
			modalProps: {
				show: false,
			},
            roleList: [],
            currentDept: {},
		};
	},
    watch: {
        selectDeptId: {
            immediate: true,
            handler (val) {
                this.formData.deptId = val;
                this.currentDept = this.companyList.filter(item=> item.id == val)[0];
            }
        }
    },
    created(){
        HttpGetAllRole().then(res=>{
            this.roleList = res.data.map(item => {
                return {label: item.name, value: item.id}
            })
        })
        if(this.type !== 'add'){
            this.getDetail()
        }
    },
	computed: {
		getBase() {
			return [{
				label: "姓名",
				tag: "vInput",
				key: "name",
				props: {
                    placeholder: '点击放大镜搜索',
					suffix: "search",
					readonly: true
				},
				on: {
					'on-icon-click': this.handleModal
				},
                span: 24,
                query: this.type == 'edit'
			},
            {
                label: "工号",
                key: "workno",
                tag: "Input",
                required: false,
                span: 24,
            },
            {
				label: "电话",
				key: "phone",
				required: false,
				query: true,
                span: 24,
			},
            {
				label: "邮箱",
				key: "mail",
				required: false,
				query: true,
                span: 24,
			},{
				label: "部门",
				key: "deptId",
				required: false,
				query: true,
                span: 24,
                tag: "vSelect",
                options: this.companyList.map(item=>{
                    return {
                        value: item.id,
                        label: item.name
                    }
                }),
			},
			{
				label: "是否主管",
				key: "manageType",
                tag: "vRadio",
                options:[
                    {label:"是", trueValue: 1},
                    {label:"否", trueValue: 0}
                ],
                span: 24,
			},
			{
				label: "审批角色",
				key: "approleIds",
                tag: "Select",
				options: this.roleList,
                props: {
                    multiple: true,
					filterable: true,
                },
				required: false,
                span: 24,
			},
            {
				label: "将员工同时添加至其他部门",
				key: "otherDeptIds",
                tag: "Select",
				options: this.companyList.filter(item => item.id !== this.formData.deptId ).map(item=>{
                    return {
                        value: item.id,
                        label: item.name
                    }
                }),
                props: {
                    multiple: true,
					filterable: true,
                },
				required: false,
                span: 24,
			},
			{
				label: "备注",
				key: "remark",
				tag: "vTextarea",
				required: false,
                span: 24,
			},
			];
		},

	},
	methods: {
		handleModal() {
			this.modalProps = {
				show: true,
				width: 'large',
				title: '查找员工',
				component: "compFindMember",
				showFooter: false,
				on: {
					'on-data': (row) => {
						this.formData = { name: row.name, phone: row.phone, mail: row.email, userId: row.id, ...this.formData };
						this.modalProps = {};
					}
				}
			}
		},
        getDetail(){
            this.loading = true
            HttpGetStaffDetail({id:this.params}).then( res => {
                this.formData.id = res.data.id;
                this.formData.userId = res.data.userId;
                this.formData.name = res.data.name;
                this.formData.workno = res.data.workno;
                this.formData.phone = res.data.phone;
                this.formData.email = res.data.email;
                this.formData.deptId = res.data.deptId;
                this.formData.manageType = res.data.manageType;
                this.formData.remark = res.data.remark;
                res.data.roleEntities.map(item=>{
                    this.formData.approleIds.push(item.id)
                });
                res.data.otherDepartmentEntities.map(item=>{
                    this.formData.otherDeptIds.push(item.id)
                });
                this.loading = false
            },err=>{
                this.$Message.error({content: err.message, duration: 10, closable: true})
                this.loading = false;
            })
        },
		close() {
			this.$emit('on-close');
		},
		async saveStaff() {
            this.formData.approleIds = this.formData.approleIds ? this.formData.approleIds.join(',') : '';
            this.formData.otherDeptIds = this.formData.otherDeptIds ? this.formData.otherDeptIds.join(',') : '';
            this.formData.orgId = this.currentDept.scope;
			this.loading = true;
            HttpAddStaff(this.formData).then(res=>{
                this.loading = false;
                this.$Message.success({content: '操作成功', duration: 10, closable: true});
                this.close()
                this.$emit('on-success')
            },err=>{
                this.$Message.error({content: err.message, duration: 10, closable: true});
                this.loading = false;
            })

		}
	}
};
</script>
